import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  width: "20px",
  height: "20px",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "broken-heart--reward-social-rating-media-heart-it-like-favorite-love-broken-break" }, [
      _createElementVNode("path", {
        id: "Subtract",
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M6.81727 2.42297C5.89642 1.57487 4.94199 1.15142 4.02368 1.08488C2.917 1.00469 1.93758 1.449 1.22866 2.15292C-0.16629 3.53804 -0.600577 6.04665 1.13372 7.78094C1.13954 7.78676 1.1455 7.79244 1.1516 7.79796L6.66842 12.7951C6.85893 12.9676 7.14924 12.9676 7.33975 12.7951L12.8566 7.79796C12.8627 7.79244 12.8686 7.78676 12.8745 7.78094C14.5998 6.05563 14.1631 3.54732 12.7727 2.16113C12.0655 1.45609 11.0881 1.00922 9.98244 1.08763C9.64869 1.1113 9.31015 1.18228 8.97017 1.30383L6.51782 5.30183L8.60275 5.64931C8.82146 5.68577 9.00448 5.83537 9.08372 6.04245C9.16296 6.24954 9.12655 6.4831 8.98804 6.65625L6.98804 9.15625C6.77241 9.42578 6.3791 9.46949 6.10956 9.25385C5.84002 9.03822 5.79632 8.64492 6.01196 8.37538L7.34651 6.70718L5.39725 6.38231C5.19218 6.34813 5.01754 6.21422 4.9313 6.02506C4.84507 5.83589 4.85854 5.61623 4.96724 5.43902L6.81727 2.42297Z",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])))
}
export default { render: render }